module.exports = __webpack_public_path__ + "static/media/autumn-soups.d62b40ab.pdf";